module.exports = __webpack_public_path__ + "img/background-desktop-top.70d8c585.svg";